import { useEffect, useState } from "react";
import { creatorFetch, creatorToken } from "../adminApi";
import { Field, ImageField, SaveBar } from "../admin/sections";
import { StatusBadge, Toggle } from "./bits";

/* ---------- আমার মঞ্চ ---------- */
export function StageTab({ data, refresh, goCustomer }) {
  const a = data.artist || {};
  const [f, setF] = useState({
    art_form: a.art_form || "",
    location: a.location || "",
    languages: a.languages || "",
  });
  const [live, setLive] = useState(a.active !== false);
  const [done, setDone] = useState(false);

  const save = async () => {
    try {
      await creatorFetch("/creator/stage-settings", { method: "PUT", body: JSON.stringify(f) });
      setDone(true);
      refresh();
      setTimeout(() => setDone(false), 2500);
    } catch (e) {
      alert(e.message);
    }
  };

  const flipLive = async () => {
    try {
      await creatorFetch("/creator/stage-settings", { method: "PUT", body: JSON.stringify({ active: !live }) });
      setLive(!live);
      refresh();
    } catch (e) {
      alert(e.message);
    }
  };

  return (
    <div className="max-w-2xl space-y-5" data-testid="creator-section-stage">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <StatusBadge live={live} testid="stage-status-badge" />
        <Toggle on={live} onChange={flipLive} label={live ? "মঞ্চ খোলা (LIVE)" : "মঞ্চ বন্ধ (DRAFT)"} testid="stage-live-toggle" />
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          data-testid="stage-see-view"
          onClick={() => goCustomer("moncho", "রং ও মঞ্চ")}
          className="rounded-full border border-gold/40 px-5 py-2.5 text-sm text-gold transition-colors hover:bg-gold hover:text-dusk"
        >
          Stage দেখুন
        </button>
        <button
          data-testid="stage-go-profile"
          onClick={() => window.dispatchEvent(new CustomEvent("creator-nav", { detail: { tab: "profile" } }))}
          className="rounded-full bg-gold px-5 py-2.5 text-sm font-medium text-dusk transition-transform hover:scale-[1.03]"
        >
          Profile সম্পাদনা করুন
        </button>
        <button
          data-testid="stage-go-add-performance"
          onClick={() => window.dispatchEvent(new CustomEvent("creator-nav", { detail: { tab: "performances", add: true } }))}
          className="rounded-full border border-gold/40 px-5 py-2.5 text-sm text-gold transition-colors hover:bg-gold hover:text-dusk"
        >
          Performance যোগ করুন
        </button>
      </div>
      <Field label="শিল্প-ঘরানা" value={f.art_form} onChange={(v) => setF({ ...f, art_form: v })} testid="stage-art-form" />
      <Field label="ঠিকানা" value={f.location} onChange={(v) => setF({ ...f, location: v })} testid="stage-location" />
      <Field label="ভাষা" value={f.languages} onChange={(v) => setF({ ...f, languages: v })} testid="stage-languages" />
      <SaveBar saving={false} done={done} onSave={save} testid="save-my-stage" />
      <p className="text-xs text-sand/45">DRAFT-এ থাকলে মঞ্চের পথ গ্রামবাসীর চোখে পড়বে না।</p>
    </div>
  );
}

/* ---------- আমার পরিবেশনা ---------- */
/* ---------- ভিডিও-আপলোড — চাঙ্কে চাঙ্কে, থামার ভয় নেই ---------- */
function VideoUpload({ value, onChange }) {
  const [pct, setPct] = useState(-1); // -1 মানে এখন কিছু জমানো চলছে না
  const [err, setErr] = useState("");
  const [fname, setFname] = useState("");

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setErr("");
    setFname(file.name);
    const ext = (file.name.split(".").pop() || "").toLowerCase();
    const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
    const head = { "Content-Type": "application/json", Authorization: `Bearer ${creatorToken()}` };
    try {
      setPct(0);
      const i = await fetch(`${API}/creator/upload/video/init`, {
        method: "POST", headers: head,
        body: JSON.stringify({ name: file.name, size: file.size }),
      });
      const id = await i.json();
      if (!i.ok) throw new Error(id.detail || "শুরু হয়নি");
      const CH = id.chunk || 2 * 1024 * 1024;
      for (let off = 0; off < file.size; off += CH) {
        const data = await new Promise((res, rej) => {
          const r = new FileReader();
          r.onload = () => res(String(r.result).split(",")[1]);
          r.onerror = rej;
          r.readAsDataURL(file.slice(off, off + CH));
        });
        const c = await fetch(`${API}/creator/upload/video/chunk`, {
          method: "POST", headers: head, body: JSON.stringify({ upload_id: id.upload_id, data }),
        });
        if (!c.ok) throw new Error((await c.json()).detail || "ভিডিওর টুকরো যায়নি");
        setPct(Math.min(99, Math.round(((off + CH) / file.size) * 100)));
      }
      const f = await fetch(`${API}/creator/upload/video/complete`, {
        method: "POST", headers: head, body: JSON.stringify({ upload_id: id.upload_id, ext }),
      });
      const done = await f.json();
      if (!f.ok) throw new Error(done.detail || "শেষ হয়নি");
      onChange(done.url);
      setPct(100);
    } catch (e2) {
      setErr(e2.message || "আপলোড হয়নি");
      setPct(-1);
    }
  };

  return (
    <div className="rounded-2xl border border-gold/20 bg-earthen/60 p-4" data-testid="video-upload">
      <p className="text-xs text-sand/60">নিজের ভিডিও জমান — MP4/WebM, ২০০ এমবি পর্যন্ত। গ্রাহক মঞ্চে "দেখুন"-এ এটাই দেখবে।</p>
      {value && pct !== 0 && pct < 100 && (
        <video src={value.startsWith("http") ? value : `${process.env.REACT_APP_BACKEND_URL}${value}`} controls playsInline data-testid="video-preview" className="mt-3 max-h-52 w-full rounded-xl bg-black" />
      )}
      {pct >= 0 && pct < 100 && (
        <div className="mt-3" data-testid="video-upload-progress">
          <div className="h-2 w-full overflow-hidden rounded-full bg-dusk">
            <div className="h-full rounded-full bg-gold transition-all duration-300" style={{ width: `${pct}%` }} />
          </div>
          <p className="mt-1.5 text-xs text-gold">{fname} — {pct}% জমানো হয়েছে…</p>
        </div>
      )}
      {pct === 100 && <p className="mt-2 text-xs text-gold" data-testid="video-upload-done">ভিডিও জমা হয়ে গেছে ✓</p>}
      <label className="mt-3 inline-flex cursor-pointer items-center gap-2 rounded-full bg-gold px-5 py-2.5 text-sm font-medium text-dusk transition-transform hover:scale-[1.03]">
        {value ? "ভিডিও বদলান" : "ভিডিও বাছুন"}
        <input type="file" accept="video/mp4,video/webm,video/quicktime,video/x-m4v,video/*" className="hidden" data-testid="video-file-input" onChange={pick} />
      </label>
      {err && <p className="mt-2 text-xs text-red-300" data-testid="video-upload-error">{err}</p>}
    </div>
  );
}

export function PerformancesTab({ data, refresh, startAdd }) {
  const [form, setForm] = useState(null);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    if (startAdd && !form) startNew();
    // eslint-disable-next-line
  }, [startAdd]);

  const startNew = () => {
    setEditId(null);
    setForm({ kind: "video", title: "", url: "", duration: "", category: "", status: "প্রকাশিত" });
  };

  const save = async () => {
    try {
      if (editId) await creatorFetch(`/creator/performances/${editId}`, { method: "PUT", body: JSON.stringify(form) });
      else await creatorFetch("/creator/performances", { method: "POST", body: JSON.stringify(form) });
      setForm(null);
      setEditId(null);
      refresh();
    } catch (e) {
      alert(e.message);
    }
  };

  const del = async (id) => {
    if (!window.confirm("পরিবেশনাটি মুছে যাবে?")) return;
    await creatorFetch(`/creator/performances/${id}`, { method: "DELETE" });
    refresh();
  };

  return (
    <div className="max-w-3xl" data-testid="creator-section-performances">
      <button data-testid="add-my-performance" onClick={startNew} className="mb-5 rounded-full bg-gold px-6 py-3 text-sm font-medium text-dusk transition-transform hover:scale-[1.03]">
        নতুন Performance যোগ করুন
      </button>
      <div className="space-y-3">
        {(data.performances || []).map((p) => (
          <div key={p.id} className="rounded-2xl border border-gold/15 bg-dusk/50 p-4" data-testid={`my-performance-${p.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="truncate font-display text-lg text-sand">{p.title}</p>
                <p className="mt-0.5 text-xs text-sand/50">{p.kind === "audio" ? "শব্দ" : "ভিডিও"} • {p.duration} • {p.category}</p>
              </div>
              <StatusBadge live={p.status !== "খসড়া"} testid={`performance-status-${p.id}`} />
            </div>
            <div className="mt-3 flex flex-wrap gap-2">
              <button
                data-testid={`edit-my-performance-${p.id}`}
                onClick={() => { setEditId(p.id); setForm({ ...p }); }}
                className="rounded-full border border-gold/30 px-4 py-1.5 text-xs text-gold transition-colors hover:bg-gold hover:text-dusk"
              >
                সাধুন
              </button>
              <button
                data-testid={`del-my-performance-${p.id}`}
                onClick={() => del(p.id)}
                className="rounded-full border border-red-400/30 px-4 py-1.5 text-xs text-red-300 transition-colors hover:bg-red-400 hover:text-dusk"
              >
                মুছুন
              </button>
            </div>
          </div>
        ))}
        {(data.performances || []).length === 0 && <p className="text-sm text-sand/50">এখনো পরিবেশনা জমানো নেই — প্রথমটা যোগ করুন।</p>}
      </div>

      {form && (
        <div className="mt-6 space-y-4 rounded-2xl border border-gold/25 bg-plaster p-5" data-testid="performance-form">
          <h4 className="font-display text-lg text-gold">{editId ? "পরিবেশনা সাধুন" : "নতুন পরিবেশনা"}</h4>
          <Field label="নাম — যেমন লালনের গান" value={form.title} onChange={(v) => setForm({ ...form, title: v })} testid="my-performance-title" />
          <div className="flex flex-wrap gap-2">
            <Toggle on={form.kind === "video"} onChange={(v) => setForm({ ...form, kind: v ? "video" : "audio" })} label={form.kind === "video" ? "ভিডিও" : "শব্দ"} testid="my-performance-kind" />
          </div>
          {form.kind === "video" ? (
            <>
              <VideoUpload value={form.url} onChange={(v) => setForm({ ...form, url: v })} />
              <details className="text-xs text-sand/45">
                <summary className="cursor-pointer">নিজের লিঙ্ক বসাতে চান?</summary>
                <div className="mt-3">
                  <Field label="ভিডিওর লিঙ্ক" value={form.url} onChange={(v) => setForm({ ...form, url: v })} testid="my-performance-url" />
                </div>
              </details>
            </>
          ) : (
            <Field label="লিঙ্ক (শব্দের ঠিকানা)" value={form.url} onChange={(v) => setForm({ ...form, url: v })} testid="my-performance-url" />
          )}
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="সময়কাল — যেমন ১ ঘণ্টা" value={form.duration} onChange={(v) => setForm({ ...form, duration: v })} testid="my-performance-duration" />
            <Field label="ঘরানা — যেমন বাউল গান" value={form.category} onChange={(v) => setForm({ ...form, category: v })} testid="my-performance-category" />
          </div>
          <SaveBar saving={false} done={false} onSave={save} testid="save-my-performance" />
          <button data-testid="cancel-my-performance" onClick={() => { setForm(null); setEditId(null); }} className="text-sm text-sand/60 hover:text-sand">বাতিল</button>
        </div>
      )}
    </div>
  );
}

/* ---------- বুকিং-সেটিংস ---------- */
export function BookingSettingsTab({ data, refresh }) {
  const a = data.artist || {};
  const [f, setF] = useState({
    performance_types: a.performance_types || a.art_form || "",
    available_locations: a.available_locations || a.location || "",
    duration_note: a.duration_note || "২ ঘণ্টার পরিবেশনা",
    price_start: a.price_start ?? 0,
    min_amount: a.min_amount ?? 0,
    travel: a.travel || "স্থানীয় খোঁজ-খবর দামের ভেতরেই",
    negotiation: a.negotiation !== false,
    unavailable_dates: (a.unavailable_dates || []).join(", "),
  });
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const save = async () => {
    setErr("");
    try {
      await creatorFetch("/creator/stage-settings", {
        method: "PUT",
        body: JSON.stringify({
          ...f,
          price_start: Number(f.price_start) || 0,
          min_amount: Number(f.min_amount) || 0,
          unavailable_dates: (f.unavailable_dates || "").split(",").map((x) => x.trim()).filter(Boolean),
        }),
      });
      setDone(true);
      refresh();
      setTimeout(() => setDone(false), 2500);
    } catch (e) {
      setErr(e.message);
    }
  };

  return (
    <div className="max-w-2xl space-y-4" data-testid="creator-section-booking-settings">
      <Field label="কী কী পরিবেশনা করেন" value={f.performance_types} onChange={(v) => setF({ ...f, performance_types: v })} testid="bs-performance-types" />
      <Field label="কোথায় কোথায় যান" value={f.available_locations} onChange={(v) => setF({ ...f, available_locations: v })} testid="bs-locations" />
      <Field label="কতক্ষণের পরিবেশনা" value={f.duration_note} onChange={(v) => setF({ ...f, duration_note: v })} testid="bs-duration" />
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label="শুরুর দাম (₹)" value={String(f.price_start ?? 0)} onChange={(v) => setF({ ...f, price_start: Number(v) || 0 })} testid="bs-price-start" />
        <Field label="ন্যূনতম বুকিং-দাম (₹)" value={String(f.min_amount ?? 0)} onChange={(v) => setF({ ...f, min_amount: Number(v) || 0 })} testid="bs-min-amount" />
      </div>
      <Field label="ভ্রমণ-নিয়ম" value={f.travel} onChange={(v) => setF({ ...f, travel: v })} testid="bs-travel" />
      <Field label="যে-দিনগুলো ব্যস্ত (তারিখ, কমায়)" value={f.unavailable_dates} onChange={(v) => setF({ ...f, unavailable_dates: v })} testid="bs-busy-dates" />
      <Toggle on={f.negotiation} onChange={(v) => setF({ ...f, negotiation: v })} label={f.negotiation ? "দরদাম: চালু" : "দরদাম: বন্ধ"} testid="bs-negotiation" />
      <p className="rounded-xl border border-vermilion/30 bg-vermilion/10 p-3 text-xs leading-relaxed text-sand/80" data-testid="bs-limit-note">
        ন্যূনতম দামের নিচে AI বা অনুরোধ কোনোটাই আপনার অনুমতি ছাড়া যাবে না।
      </p>
      {err && <p className="text-xs text-red-300">{err}</p>}
      <SaveBar saving={false} done={done} onSave={save} testid="save-booking-settings" />
    </div>
  );
}

/* ---------- আসা বুকিং-অনুরোধ ---------- */
const bn = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export function RequestsTab({ data, refresh }) {
  const [counterFor, setCounterFor] = useState(null);
  const [offer, setOffer] = useState("");
  const [busy, setBusy] = useState("");
  const [err, setErr] = useState("");

  const respond = async (code, action, off = 0) => {
    setBusy(code + action);
    setErr("");
    try {
      await creatorFetch(`/creator/bookings/${encodeURIComponent(code)}/respond`, {
        method: "POST",
        body: JSON.stringify({ action, offer: off }),
      });
      setCounterFor(null);
      setOffer("");
      refresh();
    } catch (e) {
      setErr(e.message);
    }
    setBusy("");
  };

  const badge = (st) =>
    st === "নিশ্চিত" ? "border-gold/50 bg-gold/10 text-gold"
    : st === "প্রস্তুত" ? "border-gold/40 text-gold"
    : st === "বাতিল" ? "border-red-400/40 text-red-300"
    : "border-sand/30 text-sand/60";

  return (
    <div className="max-w-3xl" data-testid="creator-section-requests">
      {(data.bookings || []).length === 0 && <p className="text-sm text-sand/50">এখনো কোনো বুকিং-অনুরোধ আসেনি।</p>}
      <div className="space-y-3">
        {(data.bookings || []).map((b) => (
          <div key={b.code} className="rounded-2xl border border-gold/15 bg-dusk/50 p-5" data-testid={`my-booking-${b.code}`}>
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div>
                <p className="font-display text-xl text-sand">{b.event_type} — {b.date} {b.time ? `• ${b.time}` : ""}</p>
                <p className="mt-1 text-sm text-sand/65">{b.location} • {b.duration} • দর্শক {b.audience || "—"}</p>
                <p className="mt-1 text-sm text-gold">বাজেট {bn(b.budget_min)}–{bn(b.budget_max)}</p>
                <p className="mt-1 text-xs text-sand/50">{b.name} • {b.phone} {b.note ? `• ${b.note}` : ""}</p>
              </div>
              <span className={`rounded-full border px-3 py-1 text-[11px] ${badge(b.status)}`} data-testid={`booking-status-${b.code}`}>{b.status}</span>
            </div>
            {b.status !== "নিশ্চিত" && b.status !== "বাতিল" && (
              <div className="mt-4 flex flex-wrap items-center gap-2">
                <button
                  data-testid={`booking-accept-${b.code}`}
                  onClick={() => respond(b.code, "accept")}
                  disabled={!!busy}
                  className="rounded-full bg-alpana px-5 py-2 text-sm font-medium text-dusk transition-transform hover:scale-105 disabled:opacity-50"
                >
                  রাজি
                </button>
                <button
                  data-testid={`booking-counter-open-${b.code}`}
                  onClick={() => { setCounterFor(counterFor === b.code ? null : b.code); setOffer(String(b.last_artist_price || b.quote || "")); }}
                  disabled={!!busy}
                  className="rounded-full border border-gold/40 px-5 py-2 text-sm text-gold transition-colors hover:bg-gold hover:text-dusk disabled:opacity-50"
                >
                  কাউন্টার-দাম
                </button>
                <button
                  data-testid={`booking-decline-${b.code}`}
                  onClick={() => respond(b.code, "decline")}
                  disabled={!!busy}
                  className="rounded-full border border-red-400/30 px-5 py-2 text-sm text-red-300 transition-colors hover:bg-red-400 hover:text-dusk disabled:opacity-50"
                >
                  বাদ দিন
                </button>
                {counterFor === b.code && (
                  <span className="flex items-center gap-2 rounded-full border border-gold/25 bg-earthen/70 py-1 pl-4 pr-1">
                    <input
                      data-testid={`booking-counter-input-${b.code}`}
                      value={offer}
                      onChange={(e) => setOffer(e.target.value)}
                      type="number"
                      placeholder="আপনার দাম"
                      className="w-28 bg-transparent py-1.5 text-sm text-sand outline-none"
                    />
                    <button
                      data-testid={`booking-counter-send-${b.code}`}
                      onClick={() => respond(b.code, "counter", Number(offer))}
                      disabled={busy === b.code + "counter" || !Number(offer)}
                      className="rounded-full bg-vermilion px-3.5 py-1.5 text-xs text-alpana disabled:opacity-40"
                    >
                      পাঠান
                    </button>
                  </span>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
      {err && <p className="mt-3 text-sm text-red-300">{err}</p>}
    </div>
  );
}
